<template>
<div class="info-card">
    <v-icon class="pr-1" color="white">info</v-icon>
    <div class="">
        {{text}}
    </div>
</div>
</template>

<script>
export default {
    props: {
        text: String,
    },
}
</script>

<style lang="stylus">
.info-card
    display: flex
    flex-wrap: nowrap
    align-items: center
    background-color: #2196f3
    padding: 5px
    font-size: 12px
    color: white
    line-height: 1rem
    border-radius: 3px
</style>
